<template>
  <div class="m-hero">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mb-6 mb-lg-0">
          <div class="m-hero__content">
            <base-image
              v-if="pageImage && pageImage[0]"
              :url="pageImage[0].url"
              :width="668"
              :height="447"
              :alt-text="pageHeadline"
              class="m-hero__figure"
              image-class="m-hero__image"
            />
            <div class="m-hero__overlay">
              <h1 class="m-hero__headline">
                {{ pageHeadline }}
              </h1>
              <div
                v-if="pageSubline"
                class="m-hero__subline"
              >
                {{ pageSubline }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(spot, i) in spots"
          :key="i"
          class="col-6 col-lg-3"
        >
          <base-link :link="spot.link.url" class="m-hero__spot">
            <base-image
              v-if="spot.image && spot.image[0]"
              :url="spot.image[0].url"
              :width="330"
              :height="447"
              :alt-text="spot.imageAltText"
              class="m-hero__spot-figure"
              image-class="m-hero__spot-image"
            />
            <span class="m-hero__spot-overlay">
              <h2 class="m-hero__spot-headline">
                {{ spot.headline }}
              </h2>
              <span
                v-if="spot.subline"
                class="m-hero__spot-subline"
                v-html="spot.subline"
              >
                <!-- subline -->
              </span>
              <span
                v-if="spot.link && spot.link.name.length"
                class="m-hero__spot-link"
              >
                {{ spot.link.name }}
                <base-icon icon="chevron-right" />
              </span>
            </span>
          </base-link>
        </div>
      </div>
      <breadcrumb v-if="isFirst && !isThemed" />
    </div>
  </div>
</template>

<script>
import { getSpots } from '@/utils/spots';
import contentMixin from '@/mixins/contentMixin';
import Breadcrumb from '@/components/molecules/Breadcrumb';
import BaseImage from '@/components/atoms/BaseImage';
import BaseLink from '@/components/atoms/BaseLink';
import BaseIcon from '@/components/atoms/BaseIcon';
export default {
  name: 'Hero',
  components: {
    BaseImage,
    BaseLink,
    BaseIcon,
    Breadcrumb
  },
  mixins: [contentMixin],
  props: {
    isFirst: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      spots: null,
      isLoading: false
    }
  },
  computed: {
    isThemed () {
      return !!this.$store.getters['content/content/getTheme'];
    },
    pageHeadline () {
      return this.$store.getters['content/content/getContent']?.meta?.title;
    },
    pageImage () {
      return this.$store.getters['content/content/getContent']?.spotContent?.spotPage_Image;
    },
    pageSubline () {
      return this.$store.getters['content/content/getContent']?.spotContent?.spotPage_subline;
    },
    culture () {
      return this.$store.getters['content/content/getContent']?.meta?.culture;
    },
    spotsParentId () {
      return this.content.spotsParentPage ? this.content?.spotsParentPage?.meta?.id : this.$store.getters['content/content/getContent']?.meta?.id;
    },
    sortByDescending () {
      return this.content.orderBy === 'Ascending' ? false : true;
    }
  },
  async created () {
    this.isLoading = true;
    this.spots = (await this.getSpots({
        parentId: this.spotsParentId,
        culture: this.culture,
        pageTypes: this.content.pageTypes,
        recursive: false,
        sortOrder: 'date',
        orderByDescending: this.sortByDescending
      })
    )?.slice(0, 2);
    this.isLoading = false;
  },
  methods: {
    getSpots
  }
}
</script>
